module.exports = __webpack_public_path__ + "img/auth-slack.f4d9ec38.svg";